/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamLangCreateViewModel } from "../types/ExamLangCreateViewModel.ts";

export const examLangCreateViewModelSchema = z.object({
  cultureInfo: z
    .string()
    .describe("Código de cultura do idioma a ser criado (ex: pt-BR, en-US).")
    .nullish(),
  instruction: z
    .string()
    .describe(
      "Instrução ou descrição do idioma de prova exibida ao aluno. Opcional.",
    )
    .nullish(),
  active: z.optional(
    z
      .boolean()
      .describe("Define se o idioma de prova estará ativo após a criação."),
  ),
}) as unknown as ToZod<ExamLangCreateViewModel>;
